module.exports = __webpack_public_path__ + "explore/images/eoy/top-publishers/ladders-2x.738daa806223907c39e125f21b924288.png";